import React, { useEffect } from "react"
import {useFetchToken} from "./useFetchToken";
import Loader from "../../components/loader/Loader";
import { prefetchServiceHubToken } from "../all-apps/serviceHubApi";

interface PermissionProviderProps {
    children?: React.ReactNode
}

const AuthorizationProvider: React.FC<PermissionProviderProps> = ({children}) => {
    const {isLoading} = useFetchToken()

    useEffect(() => {
        if (!isLoading) {
            prefetchServiceHubToken()
        }
    }, [isLoading])

    if (isLoading) return <Loader/>

    return (
        <>
            {children}
        </>
    )
}

export default AuthorizationProvider
